import { AdaptiveDialogContent } from "@/lib/components/ui/adaptive-dialog/adaptive-dialog";
import { TenantSetupWizard } from "./tenant-setup-dialog.wizard";

/**
 * TenantSetupDialogContent is the company setup inside its dialog. A click
 * outside never closes it, so a half-done setup is not lost by accident.
 */
export function TenantSetupDialogContent() {
  return (
    <AdaptiveDialogContent
      width="max-w-[min(96vw,52rem)]"
      classNames={{ root: "max-h-[88svh]", content: "p-0" }}
      onCloseAutoFocus={(event) => event.preventDefault()}
      onInteractOutside={(event) => event.preventDefault()}
    >
      <TenantSetupWizard />
    </AdaptiveDialogContent>
  );
}
